"use strict";import{tag as i}from"../custom-tag.js";export function dislikeIcon({height:e=16,width:l=16,hidden:s=!1,title:t="Dislike"}={}){return i`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${s?"true":"false"}"
      role="img"
      aria-label="${t}"
    >
      <mask
        id="dislike_svg__mask0_6875_6671"
        width="20"
        height="18"
        x="2"
        y="3"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M2 12.562c0 .876.688 1.562 1.562 1.562l4.688.002c.25 0 1.125.375.437 1.438-.437.812-.437 3.875-.437 3.875 0 .874.688 1.561 1.562 1.561s1.563-.687 1.563-1.562c0-4.562 4.375-5.938 4.375-5.938V5.375c-2-.688-2.5-1.875-5-1.875H6.061c-.876 0-1.562.688-1.562 1.562 0 .375.125.688.313.937-.876 0-1.563.688-1.563 1.563 0 .375.126.75.375 1.063-.624.25-1 .812-1 1.438 0 .374.126.75.376 1.063-.564.187-1.001.75-1.001 1.436m16.877 2.188H22V4.124h-3.125A1.88 1.88 0 0 0 16.999 6l.002 6.876a1.84 1.84 0 0 0 1.875 1.875"
        />
      </mask>
      <g mask="url(#dislike_svg__mask0_6875_6671)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=dislike.js.map
